import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../components/elements/Card';
import ErrorHandler from '../../components/elements/ErrorHandler';
import ScrollToTop from '../../components/elements/ScrollToTop';
import { AppContext } from '../../contexts';
import {
  fetchSubMerchantActivity,
  fetchSubMerchantCountDataCompleted,
  fetchSubMerchantCountDataXOnBoard,
  fetchSubMerchantCountOnboarding,
  fetchSubMerchantCountTransaction,
  fetchSubMerchantCountTrxXOnBoard,
  fetchSubMerchantRegionalActivity,
} from './actions';
import styles from './styles.scoped.css';
import SubMerchantAggregateFilter from '../../components/fragments/SubMerchantAggregateFilter';
import { Divider } from '@mantine/core';
import IconDataCompleted from '../../components/icons/IconDataCompleted';
import IconOnBoard from '../../components/icons/IconOnBoard';
import IconTransactions from '../../components/icons/IconTransactions';
import IconDataXOnBoard from '../../components/icons/IconDataXOnBoard';
import IconTrxXOnBoard from '../../components/icons/IconTrxXOnBoard';
import BarChartMonitoring from '../../components/fragments/BarChartMonitoring';
import DoughnutChartMonitoring from '../../components/fragments/DoughnutChartMonitoring';
import { thousand } from '../../utils/format';
import { fetchSessionProtection } from '../../components/layouts/PageBase/actions';


function SubMerchantAggregate() {
  const { setBreadcrumbs } = useContext(AppContext);
  const dispatch = useDispatch();
  const {
    local: { filter = null, message },
    activity,
    regionalActivity,
    countDataCompleted,
    countOnboarding,
    countTransaction,
    countDataXOnBoard,
    countTrxXOnBoard,
  } = useSelector((state) => state.subMerchantAggregate);
  const {
    dataDetailUser: { regionalId },
  } = useSelector((state) => state.pageBase);

  const fetchDataMonitoring = () => {
    dispatch(fetchSubMerchantActivity({ filter }));
    dispatch(fetchSubMerchantRegionalActivity({ filter }));
    dispatch(fetchSubMerchantCountDataCompleted({ filter }));
    dispatch(fetchSubMerchantCountOnboarding({ filter }));
    dispatch(fetchSubMerchantCountTransaction({ filter }));
    dispatch(fetchSubMerchantCountDataXOnBoard({ filter }));
    dispatch(fetchSubMerchantCountTrxXOnBoard({ filter }));
  };

  useEffect(() => {
    if (filter && filter.regional.length > 0 || !regionalId) {
      fetchDataMonitoring();
    }
  }, [filter]);

  useEffect(() => {
    dispatch(fetchSessionProtection());
    setBreadcrumbs(['Data Monitoring']);
  }, []);

  if (message) {
    return <ErrorHandler message={message} />;
  }

  return (
    <main className={styles.root}>
      <SubMerchantAggregateFilter />
      <p className={styles.titleContent}>
        Status Registrasi Berhasil, On Boarding & Transaksi Subpangkalan
      </p>
      <div className={styles.cardContainer}>
        <Card className={styles.cardItem}>
          <div>
            <small>Registrasi Berhasil</small>
            <p>{thousand(countDataCompleted.data?.total)}</p>
          </div>
          <IconDataCompleted />
        </Card>
        <Card className={styles.cardItem}>
          <div>
            <small>On Boarding</small>
            <p>{thousand(countOnboarding.data?.total)}</p>
          </div>
          <IconOnBoard />
        </Card>
        <Card className={styles.cardItem}>
          <div>
            <small>Transaksi</small>
            <p>{thousand(countTransaction.data?.total)}</p>
          </div>
          <IconTransactions />
        </Card>
      </div>
      <div className={[styles.cardContainer, styles.wide].join(' ')}>
        <Card className={styles.cardItem}>
          <div>
            <small>% Onboarding x Registrasi Berhasil</small>
            <p>{countDataXOnBoard.data?.total}%</p>
          </div>
          <IconDataXOnBoard />
        </Card>
        <Card className={styles.cardItem}>
          <div>
            <small>% Transaksi x On Boarding</small>
            <p>{countTrxXOnBoard.data?.total}%</p>
          </div>
          <IconTrxXOnBoard />
        </Card>
      </div>
      <div className={styles.cardChartContainer}>
        <Card className={[styles.cardItem, styles.cardBarChart].join(' ')}>
          <div>
            <p>Status Aktivitas Subpangkalan per Provinsi.</p>
            <small>
              Perbandingan progres Subpangkalan registrasi berhasil,
              onboarding & transaksi
            </small>
          </div>
          <Divider />
          <div>
            <BarChartMonitoring data={regionalActivity.data} isLoading={regionalActivity.loading} />
          </div>
        </Card>
        <Card className={[styles.cardItem, styles.cardDonutChart].join(' ')}>
          <div>
            <p>Status Aktivitas Subpangkalan</p>
            <small>
              Perbandingan progres Subpangkalan registrasi berhasil,
              onboarding & transaksi
            </small>
          </div>
          <Divider />
          <div>
            <DoughnutChartMonitoring data={activity.data} isLoading={activity.loading} />
          </div>
        </Card>
      </div>
      <ScrollToTop />
    </main>
  );
}

export default SubMerchantAggregate;
